export enum MotorVehicleIncidentConstants {
  SET_NUMBER_OF_VEHICLES_INVOLVED = 'motorVehicleIncident/SET_NUMBER_OF_VEHICLES_INVOLVED',
  SET_AIRBAG_DEPLOYED = 'motorVehicleIncident/SET_AIRBAG_DEPLOYED',
  SET_VEHICLE_IMPACT_SITE = 'motorVehicleIncident/SET_VEHICLE_IMPACT_SITE',
  SET_LOCATION_OF_PATIENT_IN_VEHICLE = 'motorVehicleIncident/SET_LOCATION_OF_PATIENT_IN_VEHICLE',
  SET_EXTRICATION_REQUIRED = 'motorVehicleIncident/SET_EXTRICATION_REQUIRED',
  SET_MOTOR_VEHICLE_INCIDENT = 'motorVehicleIncident/SET_MOTOR_VEHICLE_INCIDENT',
  RESET_MOTOR_VEHICLE_INCIDENT = 'motorVehicleIncident/RESET_MOTOR_VEHICLE_INCIDENT',
  CLEAR_MOTOR_VEHICLE_INCIDENT = 'motorVehicleIncident/CLEAR_MOTOR_VEHICLE_INCIDENT',
  SAVE_MOTOR_VEHICLE_INCIDENT = 'motorVehicleIncident/SAVE_MOTOR_VEHICLE_INCIDENT',
}
